import UserDoctorTypeEnum from '@enums/UserDoctorTypeEnum'

export const USER_DOCTOR_TYPES = [
  { value: UserDoctorTypeEnum.DOCTOR, label: UserDoctorTypeEnum.DOCTOR },
  { value: UserDoctorTypeEnum.EMBRYOLOGIST, label: UserDoctorTypeEnum.EMBRYOLOGIST },
  { value: UserDoctorTypeEnum.NURSING, label: UserDoctorTypeEnum.NURSING },
  { value: UserDoctorTypeEnum.WELCOMING_TEAM, label: UserDoctorTypeEnum.WELCOMING_TEAM },
  { value: UserDoctorTypeEnum.OTHERS, label: UserDoctorTypeEnum.OTHERS },
]
